/*
 * @Author: Michael 
 * @Date: 2018-01-05 10:57:18 
 * @Last Modified by: wangxiang
 * @Last Modified time: 2021-08-25 18:11:45
 */
export default {
  routes: [{
    path: '/leave',
    name: 'leave',
    component: () => import('@/module/leave/LeaveApply.vue'),
    meta: {
      title: '请假审批',
      keepAlive: false,
      logined: true
    }
  },
  {
    path: '/leave/apply/student',
    name: 'leave_apply_student',
    component: () => import('@/module/leave/ChooseLeaveStudent.vue'),
    meta: {
      title: '选择学员',
      keepAlive: false,
      logined: false
    }
  },
  {
    path: '/leave/apply/edit',
    name: 'leave_apply_edit',
    component: () => import('@/module/leave/LeaveApplyEditPage.vue'),
    meta: {
      title: '申请请假',
      keepAlive: false,
      logined: false
    }
  },
  {
    path: '/leave/apply/edit/v5',
    name: 'leave_apply_edit_v5',
    component: () => import('@/module/leave/leave_V5/LeaveApplyEditPage.vue'),
    meta: {
      title: '申请请假',
      keepAlive: true,
      logined: false
    }
    },
    {
      path: '/leave/apply/schedule',
      name: 'leave_apply_schedule',
      component: () => import('@/module/leave/leave_V5/LeaveApplySchedule.vue'),
      meta: {
        title: '选择课次',
        keepAlive: false,
        logined: false
      }
  },
  {
    path: '/leave/apply/detail/:id',
    name: 'leave_apply_detail',
    component: () => import('@/module/leave/LeaveApplyDetailPage.vue'),
    meta: {
      title: '请假详情',
      keepAlive: false,
      logined: false
    }
  },
  {
    path: '/leave/apply/detail/v5/:id',
    name: 'leave_apply_detail_v5',
    component: () => import('@/module/leave/leave_V5/LeaveApplyDetailPage.vue'),
    meta: {
      title: '请假详情',
      keepAlive: false,
      logined: false
    }
  },
  ]
}



// WEBPACK FOOTER //
// ./src/router/Leave.js